/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ReferralDateType } from './ReferralDateType';
import {
    ReferralDateTypeFromJSON,
    ReferralDateTypeFromJSONTyped,
    ReferralDateTypeToJSON,
    ReferralDateTypeToJSONTyped,
} from './ReferralDateType';
import type { ReferralType } from './ReferralType';
import {
    ReferralTypeFromJSON,
    ReferralTypeFromJSONTyped,
    ReferralTypeToJSON,
    ReferralTypeToJSONTyped,
} from './ReferralType';
import type { Recipient } from './Recipient';
import {
    RecipientFromJSON,
    RecipientFromJSONTyped,
    RecipientToJSON,
    RecipientToJSONTyped,
} from './Recipient';

/**
 * 
 * @export
 * @interface ReferralDetail
 */
export interface ReferralDetail {
    /**
     * 
     */
    referral_id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    sender_facility_id: string;
    /**
     * 
     */
    sender_organization_id: string;
    /**
     * 
     */
    target_discharge_date: Date;
    /**
     * 
     */
    date_type?: ReferralDateType;
    /**
     * 
     */
    referral_type: ReferralType;
    /**
     * 
     */
    status: ReferralDetailStatusEnum;
    /**
     * 
     */
    close_reason: ReferralDetailCloseReasonEnum | null;
    /**
     * 
     */
    sent_at: Date;
    /**
     * 
     */
    confirmed_at: Date;
    /**
     * 
     */
    closed_at: Date;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    created_by_user_id: string;
    /**
     * 
     */
    updated_at: Date;
    /**
     * 
     */
    updated_by_user_id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    dob: Date;
    /**
     * 
     */
    latest_activity_at?: Date;
    /**
     * 
     */
    recipients: Array<Recipient>;
}


/**
 * @export
 */
export const ReferralDetailStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Confirmed: 'confirmed',
    Closed: 'closed',
} as const;
export type ReferralDetailStatusEnum = typeof ReferralDetailStatusEnum[keyof typeof ReferralDetailStatusEnum];

/**
 * @export
 */
export const ReferralDetailCloseReasonEnum = {
    ConfirmedElsewhere: 'confirmed_elsewhere',
    Declined: 'declined',
    Lost: 'lost',
    Withdrawn: 'withdrawn',
} as const;
export type ReferralDetailCloseReasonEnum = typeof ReferralDetailCloseReasonEnum[keyof typeof ReferralDetailCloseReasonEnum];


/**
 * Check if a given object implements the ReferralDetail interface.
 */
export function instanceOfReferralDetail(value: object): value is ReferralDetail {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('sender_organization_id' in value) || value['sender_organization_id'] === undefined) return false;
    if (!('target_discharge_date' in value) || value['target_discharge_date'] === undefined) return false;
    if (!('referral_type' in value) || value['referral_type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('close_reason' in value) || value['close_reason'] === undefined) return false;
    if (!('sent_at' in value) || value['sent_at'] === undefined) return false;
    if (!('confirmed_at' in value) || value['confirmed_at'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('updated_by_user_id' in value) || value['updated_by_user_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('dob' in value) || value['dob'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function ReferralDetailFromJSON(json: any): ReferralDetail {
    return ReferralDetailFromJSONTyped(json, false);
}

export function ReferralDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'lead_id': json['lead_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_organization_id': json['sender_organization_id'],
        'target_discharge_date': (json['target_discharge_date'] == null ? json['target_discharge_date'] : parseDate(json['target_discharge_date'])),
        'date_type': json['date_type'] == null ? undefined : ReferralDateTypeFromJSON(json['date_type']),
        'referral_type': ReferralTypeFromJSON(json['referral_type']),
        'status': json['status'],
        'close_reason': json['close_reason'],
        'sent_at': (json['sent_at'] == null ? json['sent_at'] : parseDateTime(json['sent_at'])),
        'confirmed_at': (json['confirmed_at'] == null ? json['confirmed_at'] : parseDateTime(json['confirmed_at'])),
        'closed_at': (json['closed_at'] == null ? json['closed_at'] : parseDateTime(json['closed_at'])),
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'created_by_user_id': json['created_by_user_id'],
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
        'updated_by_user_id': json['updated_by_user_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': (json['dob'] == null ? json['dob'] : parseDate(json['dob'])),
        'latest_activity_at': json['latest_activity_at'] == null ? undefined : (parseDateTime(json['latest_activity_at'])),
        'recipients': ((json['recipients'] as Array<any>).map(RecipientFromJSON)),
    };
}

export function ReferralDetailToJSON(json: any): ReferralDetail {
    return ReferralDetailToJSONTyped(json, false);
}

export function ReferralDetailToJSONTyped(value?: ReferralDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'lead_id': value['lead_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_organization_id': value['sender_organization_id'],
        'target_discharge_date': value['target_discharge_date'] == null ? value['target_discharge_date'] : serializeDate(value['target_discharge_date']),
        'date_type': ReferralDateTypeToJSON(value['date_type']),
        'referral_type': ReferralTypeToJSON(value['referral_type']),
        'status': value['status'],
        'close_reason': value['close_reason'],
        'sent_at': value['sent_at'] == null ? value['sent_at'] : serializeDateTime(value['sent_at']),
        'confirmed_at': value['confirmed_at'] == null ? value['confirmed_at'] : serializeDateTime(value['confirmed_at']),
        'closed_at': value['closed_at'] == null ? value['closed_at'] : serializeDateTime(value['closed_at']),
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'created_by_user_id': value['created_by_user_id'],
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
        'updated_by_user_id': value['updated_by_user_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'] == null ? value['dob'] : serializeDate(value['dob']),
        'latest_activity_at': value['latest_activity_at'] == null ? value['latest_activity_at'] : serializeDateTime(value['latest_activity_at']),
        'recipients': ((value['recipients'] as Array<any>).map(RecipientToJSON)),
    };
}

